module.exports = __webpack_public_path__ + "static/media/logo.00dde438.svg";